import { render, staticRenderFns } from "./MultiImageUpload.vue?vue&type=template&id=4478251a&scoped=true"
import script from "./MultiImageUpload.vue?vue&type=script&lang=js"
export * from "./MultiImageUpload.vue?vue&type=script&lang=js"
import style0 from "./MultiImageUpload.vue?vue&type=style&index=0&id=4478251a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478251a",
  null
  
)

export default component.exports